<script setup lang="ts">
/**
 * Marks a control whose UI exists but whose system does not yet.
 *
 * The layout was built from the design ahead of the features behind it, which
 * is a deliberate order of work — but a control that looks live and does
 * nothing is the worst outcome of that choice, so everything still waiting
 * carries this and is `disabled`. One component, so the treatment cannot
 * drift into three different-looking kinds of "not yet".
 *
 * When the system behind a control lands, the badge and the `disabled` come
 * off together and nothing else about it changes.
 */
import { useI18n } from '../i18n/index.ts';

const { t } = useI18n();
</script>

<template>
  <span
    class="shrink-0 rounded-full bg-surface-container-high px-1.5 py-0.5 text-label-sm leading-none text-on-surface-variant"
  >
    {{ t('common.soon') }}
  </span>
</template>
